import React, { useMemo } from 'react';
import Select from 'react-select';
import useSchemaStore from '../../store/schemaStore';

const UniqueKeys = () => {
  const { uniqueKeys, updateUniqueKey, fields, removeUniqueKey } = useSchemaStore();
  const options = useMemo(() => fields.map((field) => ({
    value: field.name,
    label: field.name
  })), [fields]);
  return (
      <>
      {uniqueKeys.length > 0 && (
        <table className="foreignKeys table mt-4">
          <thead>
            <tr>
              <th>🏷️ Select Unique Constraint/s</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {uniqueKeys.map((uk, index) => (
              <tr
                key={`uk-${index}`}
                className={`${uk.isInvalid ? "tr-invalid tr-shake" : ""}`}
              >
                <td>
                  <Select
                    value={options.filter(option => uk.uniqueColumns.includes(option.value))}
                    isMulti 
                    name="uniqueColumns"
                    options={options}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    onChange={(selectedOptions) => {
                      const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
                      updateUniqueKey(index, selectedValues);
                    }}
                  />
                </td>
                <td>
                  <button
                    className="btn btn-danger"
                    onClick={() => removeUniqueKey(index)}
                  >
                    Remove
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      </>
  );
};

export default React.memo(UniqueKeys);